import * as XLSX from 'xlsx';

const transformInwardRequestData = (requests: any[]) => {
  return requests.map(req => ({
    'Sent Date': formatDate(req.respondedDate),
    'Product Name': req.productName,
    'Quantity': req.quantity,
    'Sent By (POS Code)': req.requestToPosCode,
    'Sent To (POS Code)': req.requestFromPosCode,
  }));
};

const formatDate = (dateStr: string) => {
  const dt = new Date(dateStr);
  return `${dt.getDate().toString().padStart(2, '0')}-${(dt.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${dt.getFullYear()}`;
};

export const InwardRequestExport = (requests: any[]) => {
  const data = transformInwardRequestData(requests);
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
  const headers = ['Sent Date', 'Product Name', 'Quantity', 'Sent By (POS Code)', 'Sent To (POS Code)'];

  headers.forEach((header, idx) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
    ws[cellRef] = { t: 's', v: header, s: { font: { bold: true } } };
  });

  XLSX.utils.book_append_sheet(wb, ws, 'Inward Requests');
  XLSX.writeFile(wb, 'Inward_Requests.xlsx');
};
